import CodeBlock, { CodeBlockOptions } from '@tiptap/extension-code-block'
import { DOMOutputSpec, Node as ProseMirrorNode } from 'prosemirror-model';
import { Subject } from 'rxjs';

import { AnyncHighlightPlugin } from './async-highlight-plugin'
import { getUuid } from '@models/utils/uuid';

export interface VzCodeBlockAsyncOptions extends CodeBlockOptions {
    hlWorker: Worker,
    hlWorkerMessage: Subject<any>,
    renderControls: (props: {
        options: VzCodeBlockAsyncOptions,
        node: ProseMirrorNode,
    }) => string | HTMLElement,
    renderHeader: (props: { options: VzCodeBlockAsyncOptions, node: ProseMirrorNode }) => DOMOutputSpec,
    renderFooter: (props: { options: VzCodeBlockAsyncOptions, node: ProseMirrorNode }) => DOMOutputSpec,
    onDestroy: (options: VzCodeBlockAsyncOptions) => void,
    cmpRef: any,
    id: string,
}

export const VzCodeBlockAsync = CodeBlock.extend<VzCodeBlockAsyncOptions>({
    addOptions() {
        return {
            ...this.parent?.(),
            defaultLanguage: null,
        } as any
    },

    addAttributes() {
        return {
            language: {
                default: null,
                parseHTML: element => {
                    const languageClassPrefix = 'language-';
                    const classNames = [...((element as any).firstElementChild?.classList || [])];
                    const languages = classNames
                        .filter(className => className.startsWith(languageClassPrefix))
                        .map(className => className.replace(languageClassPrefix, ''));
                    const language = languages[0];

                    if (!language) {
                        return null;
                    }
                    // console.log('[VzCodeBlock] id:', this.options.id, 'language:', language);
                    return language;
                },
                rendered: false,
            },
            sid: {
                default: getUuid().substring(0, 8),
                parseHTML: element => {
                    const sid = element.getAttribute('data-sid');
                    // console.log('[VzCodeBlock] id:', this.options.id, 'sid:', sid, 'element:', element);
                    return sid;
                },
                rendered: false,
            }
        }
    },

    parseHTML() {
        return [
            {
                tag: 'code',
                preserveWhitespace: 'full',
            },
        ]
    },

    addProseMirrorPlugins() {
        return [
            ...(this.parent?.() || []),
            AnyncHighlightPlugin({
                name: this.name,
                hlWorker: this.options.hlWorker,
                hlWorkerMessage: this.options.hlWorkerMessage
            }),
        ]
    },
    renderHTML({ node }) {
        return this.options.renderHeader({ options: this.options, node });
    },
    onDestroy() {
        this.options.onDestroy(this.options);
    }
});
